import * as React from "react";

import { nullToEmpty } from "../../utils/string";

import * as theme from "./theme.css";

interface HeaderProps {
    className?: string;
    children?: React.ReactNode;
}

function H1(props: HeaderProps) {
    const { className, children } = props;
    return (
        <h1 className={`${theme.h1} ${nullToEmpty(className)}`}>{children}</h1>
    );
}

function H2(props: HeaderProps) {
    const { className, children } = props;
    return (
        <h2 className={`${theme.h2} ${nullToEmpty(className)}`}>{children}</h2>
    );
}

function H3(props: HeaderProps) {
    const { className, children } = props;
    return (
        <h3 className={`${theme.h3} ${nullToEmpty(className)}`}>{children}</h3>
    );
}

function A(props: AProps) {
    const { className, href, onClick, children } = props;
    return (
        <a
            className={`${theme.a} ${nullToEmpty(className)}`}
            href={href}
            onClick={onClick}
        >
            {children}
        </a>
    );
}

interface AProps {
    className?: string;
    href?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    children?: React.ReactNode;
}

function Label(props: LabelProps) {
    const { className, htmlFor, children } = props;
    return (
        <label
            className={`${theme.label} ${nullToEmpty(className)}`}
            htmlFor={htmlFor}
        >
            {children}
        </label>
    );
}

interface LabelProps {
    className?: string;
    htmlFor?: string;
    children?: React.ReactNode;
}

export { H1, H2, H3, A, Label };
